import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import Table from '../../components/Relatorios/Table';
import {useTranslation} from 'react-i18next';
import DrawerFilter from '../../components/Relatorios/DrawerFilter';
import {getDados, getMarcas, getRepresentantes} from '../requests';
import {getMotivosPerdaNegocio} from '../../components/Negocios/api';
import {useHistory} from 'react-router-dom';

function Relatorios() {
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const [relatorioSelecionado, setRelatorioSelecionado] = useState('');

    const history = useHistory();

    //FILTROS
    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroData, setFiltroData] = useState({startDate: null, endDate: null});
    const [filtroNegocio, setFiltroNegocio] = useState('');
    const [filtroGestorCliente, setFiltroGestorCliente] = useState([]);
    const [filtroMarca, setFiltroMarca] = useState(null);
    const [filtroCliente, setFiltroCliente] = useState('');
    const [filtroObs, setFiltroObs] = useState('');
    const [filtroMotivo, setFiltroMotivo] = useState(null);
    const [filtroValor, setFiltroValor] = useState(0);
    const [filtroConcorrencia, setFiltroConcorrencia] = useState(null);
    const [filtroMarcaModelo, setFiltroMarcaModelo] = useState('');

    //ARRAYS
    const [arrayGestorCliente, setArrayGestorCliente] = useState([]);
    const [arrayMarcas, setArrayMarcas] = useState([]);
    const [arrayMotivos, setArrayMotivos] = useState([]);
    const [arrayConcorrentes, setArrayConcorrentes] = useState([]);

    const handleRowClick = dados => {
        history.push(`NegociosEtapas`, {
            proposta: dados,
        });
    };

    useEffect(() => {
        setLoading(true);
        var promises = [];

        promises.push(
            getRepresentantes(lang).then(res => {
                if (res.data.success) {
                    setArrayGestorCliente(res.data.representantes);
                }
            }),
        );
        promises.push(
            getMarcas(lang).then(res => {
                if (res.data.success) {
                    setArrayMarcas(res.data.marcas);
                }
            }),
        );
        promises.push(
            getMotivosPerdaNegocio(lang).then(res => {
                if (res.data.success) {
                    setArrayMotivos(res.data.motivosPerdaNegocio);
                }
            }),
        );
        promises.push(
            getDados(lang).then(res => {
                if (res.data.success) {
                    var comps1 = [];
                    res.data.concorrentes.forEach(element => {
                        const conc = {
                            value: element.id,
                            label: element.descricao,
                        };
                        comps1.push(conc);
                    });
                    setArrayConcorrentes(comps1);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div className="flex flex-row justify-end dark:text-gray-400 text-gray-500">
                    <DrawerFilter
                        arrayConcorrentes={arrayConcorrentes}
                        arrayGestorCliente={arrayGestorCliente}
                        arrayMarcas={arrayMarcas}
                        arrayMotivos={arrayMotivos}
                        filtroCodigo={filtroCodigo}
                        setFiltroCodigo={setFiltroCodigo}
                        setFiltroData={setFiltroData}
                        filtroData={filtroData}
                        filtroNegocio={filtroNegocio}
                        setFiltroNegocio={setFiltroNegocio}
                        filtroGestorCliente={filtroGestorCliente}
                        setFiltroGestorCliente={setFiltroGestorCliente}
                        filtroMarca={filtroMarca}
                        setFiltroMarca={setFiltroMarca}
                        filtroCliente={filtroCliente}
                        setFiltroCliente={setFiltroCliente}
                        filtroObs={filtroObs}
                        setFiltroObs={setFiltroObs}
                        filtroMotivo={filtroMotivo}
                        setFiltroMotivo={setFiltroMotivo}
                        filtroValor={filtroValor}
                        setFiltroValor={setFiltroValor}
                        filtroConcorrencia={filtroConcorrencia}
                        setFiltroConcorrencia={setFiltroConcorrencia}
                        filtroMarcaModelo={filtroMarcaModelo}
                        setFiltroMarcaModelo={setFiltroMarcaModelo}
                    />
                </div>
            </div>

            <Table
                arrayConcorrentes={arrayConcorrentes}
                arrayGestorCliente={arrayGestorCliente}
                arrayMarcas={arrayMarcas}
                arrayMotivos={arrayMotivos}
                filtroCodigo={filtroCodigo}
                setFiltroCodigo={setFiltroCodigo}
                loading={loading}
                setLoading={setLoading}
                onRowClick={handleRowClick}
                setFiltroData={setFiltroData}
                filtroData={filtroData}
                filtroNegocio={filtroNegocio}
                setFiltroNegocio={setFiltroNegocio}
                filtroGestorCliente={filtroGestorCliente}
                setFiltroGestorCliente={setFiltroGestorCliente}
                filtroMarca={filtroMarca}
                setFiltroMarca={setFiltroMarca}
                filtroCliente={filtroCliente}
                setFiltroCliente={setFiltroCliente}
                filtroObs={filtroObs}
                setFiltroObs={setFiltroObs}
                filtroMotivo={filtroMotivo}
                setFiltroMotivo={setFiltroMotivo}
                filtroValor={filtroValor}
                setFiltroValor={setFiltroValor}
                filtroConcorrencia={filtroConcorrencia}
                setFiltroConcorrencia={setFiltroConcorrencia}
                filtroMarcaModelo={filtroMarcaModelo}
                setFiltroMarcaModelo={setFiltroMarcaModelo}
            />
        </>
    );
}

export default Relatorios;
